<template>
  <div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="ts-flex ts-space-x-3 ts-items-end">
            <div style="width: 350px;">
              <label>{{ $t('tracking.dateRange') }}</label>
              <a-range-picker
                v-model="model.dateRange"
                :allowClear="false"
                format="DD-MM-YYYY HH:mm:ss"
                valueFormat="DD-MM-YYYY HH:mm:ss"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </div>
            <div class="ts-w-64">
              <label>{{ $t('tracking.groupName') }}</label>
              <a-select
                class="ts-w-64"
                v-model="model.group_id"
                :options="groups"
                showSearch
                :filterOption="filterOption"
                :placeholder="$t('tracking.groupName')"
                @change="clearOnChangeGroup"
              ></a-select>
              <div class="ts-text-red-600" v-if="errors.has('group_id')">
                {{ errors.first('group_id') }}
              </div>
            </div>
            <div class="ts-w-64">
              <label>{{ $t('tracking.employee') }}</label>
              <a-select
                class="ts-w-64"
                v-model="model.employee_id"
                :options="employees"
                showSearch
                :filterOption="filterOption"
                :placeholder="$t('tracking.employee')"
              ></a-select>
              <div class="ts-text-red-600" v-if="errors.has('employee_id')">
                {{ errors.first('employee_id') }}
              </div>
            </div>
            <ts-button
              color="primary"
              @click.prevent="fetchLocation"
              class="ts-h-8"
              >{{ $t('view') }}</ts-button
            >
            <ts-button
              color="info"
              outline
              class="ts-h-8"
              @click.prevent="onExportExcel"
            >
              <i class="fas fa-file-excel"></i>
              {{ $t('excel') }}</ts-button
            >
          </div>
        </ts-card-wrapper>
        <gmap-map
          ref="gmap"
          :center="center"
          :zoom="zoom"
          style="width:100%;  height: calc(100vh - 103px)"
        >
          <gmap-marker
            v-for="(marker, index) in markers"
            :key="index"
            :position="marker"
            :icon="{
              url: pointMarker,
              scaledSize: { width: 30, height: 45 }
            }"
          />
        </gmap-map>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { uniqBy, trim } from 'lodash'
import pointMarker from '@/assets/marker/point.svg'
import * as FileDownload from 'downloadjs'
export default {
  data() {
    return {
      pointMarker,
      errors: new Errors(),
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      zoom: 8,
      loading: false,
      resources: [],
      markers: [],
      model: {
        group_id: '',
        dateRange: [
          moment()
            .startOf('days')
            .format('DD-MM-YYYY HH:mm:ss'),
          moment()
            .endOf('days')
            .format('DD-MM-YYYY HH:mm:ss')
        ],
        employee_id: ''
      }
    }
  },
  created() {
    this.fetchGroup()
  },
  computed: {
    groups() {
      let list = [
        {
          label: 'All',
          value: ''
        }
      ]
      this.resources.forEach(element => {
        list.push({
          label: element.group_name,
          value: element.id
        })
      })
      return list
    },
    employees() {
      let list = [
        {
          label: 'All',
          value: ''
        }
      ]
      const emp = [
        ...this.resources
          .filter(r => r.id === this.model.group_id)
          .flatMap(element => element.group_user)
      ]
      emp
        .filter(e => e.employee_id !== null)
        .forEach(el => {
          list.push({
            label: el.user_name,
            value: el.employee_id
          })
        })
      return uniqBy(list, 'value')
    }
  },
  methods: {
    moment,
    ...mapActions('sale/locationTracking', [
      'getEmployee',
      'getUserGroup',
      'historyVisited',
      'historyVisitedExcel'
    ]),
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    fetchGroup() {
      this.loading = true
      this.getUserGroup()
        .then(group => {
          this.resources = group.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    clearOnChangeGroup() {
      this.model.employee_id = ''
    },
    fetchLocation() {
      this.loading = true
      this.markers = []
      this.historyVisited(this.model)
        .then(response => {
          response.data.forEach(el => {
            this.markers.push({
              lat: el.lat,
              lng: el.lng
            })
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onExportExcel() {
      this.loading = true
      this.errors = new Errors()
      this.historyVisitedExcel(this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
